export default __webpack_public_path__ + "static/media/Shower_Icon_B.abd61b66.svg";